<template>
  <div class="container py-2 px-0 px-sm-2">
    <div class="row">
      <div class="col-12 col-md-9 mx-auto">
        <div class="accordion accordion-modern vehicle-register" id="vehicle-register-accordion">
          <v-collapse-group>
            <!-- Vehicle Type -->
            <div class="card card-default">
              <v-collapse-wrapper :active="true">
                <div class="card-header" v-collapse-toggle>
                  <h4 class="card-title m-0 text-color-dark-blue">
                    <a class="accordion-toggle">
                      <i class="fas fa-car"></i>
                      {{ trans('Vehicle Type') }}
                    </a>
                  </h4>
                </div>
                <div v-collapse-content>
                  <vehicle-filter
                    :vehicle-manufacturer.sync="formData.vehicleManufacturer"
                    :vehicle-model.sync="formData.vehicleModel"
                    :vehicle-body-type.sync="formData.vehicleBodyType"
                    :production-year.sync="formData.production_year"
                    :color.sync="formData.color"
                    :vin.sync="formData.vin"
                    :reg_date.sync="formData.reg_date"
                    :reg_plate.sync="formData.reg_plate"
                    :fuel.sync="formData.fuel"
                    :power.sync="formData.power"
                    :capacity.sync="formData.capacity"
                    :transmission.sync="formData.transmission"
                    :speedometer_mph.sync="formData.speedometer_mph"
                    :odometer.sync="formData.odometer"
                    :errors="errors"
                  />
                </div>
              </v-collapse-wrapper>
            </div>

            <!-- Vehicle Photos -->
            <div class="card card-default">
              <v-collapse-wrapper>
                <div class="card-header" v-collapse-toggle>
                  <h4 class="card-title m-0 text-color-dark-blue">
                    <a class="accordion-toggle">
                      <i class="far fa-images"></i>
                      {{ trans('Vehicle Photos') }}
                    </a>
                  </h4>
                </div>
                <div id="collapsePhotos" v-collapse-content>
                  <vehicle-photos
                    :api-route="photoUploadRoute"
                    :photos.sync="formData.photos"
                    :errors="errors"
                  />
                </div>
              </v-collapse-wrapper>
            </div>

            <!-- Vehicle Techs -->
            <div class="card card-default">
              <v-collapse-wrapper>
                <div class="card-header" v-collapse-toggle>
                  <h4 class="card-title m-0 text-color-dark-blue">
                    <a class="accordion-toggle">
                      <i class="fas fa-cogs"></i>
                      {{ trans('Technical Details / Equipment') }}
                    </a>
                  </h4>
                </div>
                <div id="collapseTechs" v-collapse-content>
                  <vehicle-techs
                    :engine-number.sync="formData.engine_number"
                    :gearbox-number.sync="formData.gearbox_number"
                    :engine.sync="formData.engine"
                    :extras.sync="formData.extras"
                    :seat-material.sync="formData.seat_material"
                    :interior-color.sync="formData.interior_color"
                    :rims.sync="formData.rims"
                    :rims-manufacturer.sync="formData.rims_manufacturer"
                    :tyres.sync="formData.tyres"
                    :special-signs.sync="formData.special_signs"
                    :errors="errors"
                  />
                </div>
              </v-collapse-wrapper>
            </div>

            <!-- Vehicle Insurance -->
            <div class="card card-default">
              <v-collapse-wrapper :active="true">
                <div class="card-header" v-collapse-toggle>
                  <h4 class="card-title m-0 text-color-dark-blue">
                    <a class="accordion-toggle">
                      <i class="fas fa-file-contract"></i>
                      {{ trans('Contracts & Other') }}
                    </a>
                  </h4>
                </div>
                <div id="collapseInsurance" v-collapse-content>
                  <vehicle-insurance
                    :leasing-company.sync="formData.leasing_company"
                    :insurance-company.sync="formData.insurance_company"
                    :tracker-id.sync="formData.tracker_id"
                    :microdots-pin.sync="formData.microdots_pin"
                    :nfc-id.sync="formData.nfc_id"
                    :nfc-buy.sync="formData.needs_nfc"
                    :has-alarm.sync="formData.has_alarm"
                    :has-immobilizer.sync="formData.has_immobilizer"
                    :errors="errors"
                  />
              </div>
              </v-collapse-wrapper>
            </div>

            <!-- Vehicle Theft -->
            <div class="card card-default">
                <v-collapse-wrapper>
                  <div class="card-header" v-collapse-toggle>
                    <h4 class="card-title m-0 text-color-dark-blue">
                      <a class="accordion-toggle">
                        <i class="fas fa-car-crash"></i>
                        {{ trans('Theft') }}
                      </a>
                    </h4>
                  </div>
                  <div id="collapseTheft" v-collapse-content>
                    <vehicle-theft
                      :is-stolen.sync="formData.is_stolen"
                      :street.sync="formData.street"
                      :place.sync="formData.postal_code"
                      :time-from.sync="formData.time_from"
                      :time-to.sync="formData.time_to"
                      :description.sync="formData.description"
                      :reward.sync="formData.reward"
                      :police-document.sync="formData.police_document"
                      :police-department.sync="formData.police_department"
                      :police-contact.sync="formData.police_contact"
                      :police-phone.sync="formData.police_phone"
                      :leasing-company.sync="formData.leasing_company"
                      :insurance-company.sync="formData.insurance_company"
                      :errors="errors"
                    />
                </div>
                </v-collapse-wrapper>
              </div>
          </v-collapse-group>
        </div>

        <div class="form-row flex-row-reverse mt-3">
          <div class="form-group col-12">
            <label class="font-weight-bold text-dark text-2">{{ trans('Leave a message for admin') }}</label>
            <label class="text-dark text-1">{{ trans('(it won\'t be published)') }}</label>
            <custom-textarea v-model="formData.admin_comment" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-9 mx-auto text-center text-md-left">
        <div class="actions-continue">
          <input
            type="button"
            :value="trans('Register')"
            @click.prevent="sendData"
            :disabled="submitDisabled"
            class="btn btn-primary btn-modern text-uppercase mt-5 mb-5 mb-lg-0"
          >
        </div>
      </div>
    </div>

    <div v-show="loading" class="modal-backdrop fade show">
      <div style="margin-top: calc(50vh - 12px);">
        <preloader :loading="true" color="#fff" />
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import VueCollapse from 'vue2-collapse';

  import VehicleFilter from './Register/VehicleFilter';
  import VehiclePhotos from './Register/VehiclePhotos';
  import VehicleTechs from './Register/VehicleTechs';
  import VehicleInsurance from './Register/VehicleInsurance';
  import VehicleTheft from './Register/VehicleTheft';
  import CustomTextarea from './Register/VehicleTheft/CustomTextarea';
  import NfcIdSet from "./Register/NfcIdSet";
  import {getOffsetTop} from '../modules/get-offset-top';

  import { apiClient } from '../api';

  Vue.use(VueCollapse);

  export default {
    name: "VehicleRegister",

    components: {
      VehicleFilter,
      VehiclePhotos,
      VehicleTechs,
      VehicleInsurance,
      VehicleTheft,
      CustomTextarea,
      NfcIdSet,
    },

    props: {
      photoUploadRoute: {
        type: String,
        required: true,
      },
      vehicleRegisterRoute: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        submitDisabled: false,
        loading: false,
        formData: {
          vehicleManufacturer: null,
          vehicleModel: null,
          vehicleBodyType: null,
          production_year: null,
          color: {
            color: null,
            is_metallic: false,
          },
          vin: null,
          reg_date: {
            month: null,
            year: null,
          },
          reg_plate: null,
          fuel: null,
          power: null,
          capacity: null,
          transmission: null,
          speedometer_mph: false,
          odometer: null,

          engine_number: null,
          gearbox_number: null,
          engine: {
            arrangement: null,
            cylinder_count: null,
          },
          extras: [],
          seat_material: null,
          interior_color: null,
          rims: null,
          rims_manufacturer: null,
          tyres: null,
          special_signs: null,

          leasing_company: null,
          insurance_company: null,
          tracker_id: null,
          microdots_pin: null,
          nfc_id: null,
          needs_nfc: false,
          has_nfc: false,
          has_alarm: false,
          has_immobilizer: false,

          is_stolen: false,
          street: null,
          postal_code: null,
          time_from: null,
          time_to: null,
          reward: null,
          description: null,
          police_document: null,
          police_department: null,
          police_contact: null,
          police_phone: null,
          ad_confirmation: null,
          photos: [],

          discount: null,
          admin_comment: null,
        },
        discountPrice: null,
        discountLoading: false,
        isNfcIdFocused: false,
        errors: {},
      }
    },

    computed: {
      filteredFormData() {
        return this.filterObject(this.formData);
      },

      plan() {
        if (this.formData.needs_nfc || this.formData.nfc_id || this.formData.has_nfc || this.isNfcIdFocused) {
          return MICARE_PS;
        } else if (this.formData.is_stolen) {
          return MICARE_STOLEN;
        } else {
          return MICARE_CLASSIC;
        }
      },
    },

    methods: {
      hasError(fieldName) {
        return this.errors.hasOwnProperty(fieldName);
      },


      filterObject(obj) {
        return Object.fromEntries(Object.entries(obj).filter(([key, val]) => {
          if (val === null) {
            return false;
          }

          if (typeof(val) === 'string') {
            return val.trim();
          }

          if (typeof(val) === 'object') {
            const result = this.filterObject(val);
            return !!Object.keys(result).length;
          }

          return val;
        }));
      },

      sendData() {
        this.loading = true;
        this.submitDisabled = true;
        this.errors = {};

        apiClient
          .post(this.vehicleRegisterRoute, this.filteredFormData)
          .then(response => {
            sessionStorage.removeItem('vehicleReportFormData');

            this.$nextTick(() => {
              document.location.href = response.data.result;
            });
          })
          .catch(error => {
            if (error.response.status === 422) {
              const data = error.response.data;
              this.errors = data.errors;

              this.$nextTick(() => {
                const errorLabel = document.querySelector('label.error');
                if (errorLabel) {
                  /* Scroll to first error if any */
                  window.scrollTo({
                    behavior: 'smooth',
                    top: getOffsetTop(errorLabel.parentNode) - (parseFloat(
                      document.defaultView.getComputedStyle(
                        document.querySelector('#header')
                      ).height) || 0)
                  });

                  /* Show toast */
                  this.$toasted.show(errorLabel.innerText, { type: 'error' });

                  /* Open collapsed sections with errors */
                  document.querySelectorAll('.collapse').forEach(section => {
                    const errorLabels = section.querySelectorAll('label.error');
                    if (errorLabels && errorLabels.length) {
                      section.classList.add('show');
                    }
                  });
                }
              });
            } else if (error.response.status === 401) {
              this.$nextTick(() => {
                this.$toasted.show('Unauthorized', { type: 'error' });
              });
            } else if (error && error.response && error.response.status) {
              this.$nextTick(() => {
                this.$toasted.show('Unknown Error #' + error.response.status, { type: 'error' });
              });
            } else {
              this.$nextTick(() => {
                this.$toasted.show('Unknown Error', { type: 'error' });
              });
            }

            this.loading = false;
            this.submitDisabled = false;
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./resources/sass/variables";
  @import "./resources/sass/colors";

  .card-title i {
    min-width: 20px;
  }

  .sticky-top-plan {
    position: sticky !important;
    top: calc(#{$headerHeight} + 0.5rem);
  }

  .card-plan {
    border: 4px solid #F7F7F7;

    .card-header {
      padding: 10px 20px;
      border: none;
    }

    .plan-price {
      font-size: 2rem;
      font-weight: bold;
      white-space: nowrap;
    }
  }
</style>
